export function addToArray(newItem, collection, index) {
    return [...collection.slice(0, index), newItem, ...collection.slice(index)];
}

export function removeFromArray(collection, index) {
    return [...collection.slice(0, index), ...collection.slice(index + 1)];
}

export function moveInArray(collection, sourceIndex, destinationIndex) {
    const newCollection = [...collection];
    const [reorderItem] = newCollection.splice(sourceIndex, 1);
    newCollection.splice(destinationIndex, 0, reorderItem);

    return newCollection;
}
